// extracted by mini-css-extract-plugin
export default {"root":"root--KPg5t","textFieldReversedColors":"textFieldReversedColors--veOOA"};